import styled, { css } from 'styled-components';
import { Link, ExternalLink, IconButton } from 'shared-components';
import Container from '../Container';
import { HEADER_HEIGHT, LOGO_HEIGHT, responsiveHeight } from './dimensions';

// Client header background (image over colour); also used by the mobile slide-out menu
export const headerBackground = ({ theme }) =>
  theme.brand.headerBackgroundImage
    ? `background: url(${theme.brand.headerBackgroundImage}), ${theme.brand.headerBackground || '#0D256D'};
       background-size: cover;
    `
    : `background: ${theme.brand.headerBackground || '#0D256D'};`;

// Header Logo Styles *****
// Shared by the external and router logo links
const logoLinkStyles = css`
  display: flex;
  align-items: center;
  ${responsiveHeight(LOGO_HEIGHT, h => `height: ${h}px;`)}

  max-width: 85%;

  ${({ theme }) => theme.media.tabletPortraitUp`
   max-width: 75%;
  `}

  ${({ theme }) => theme.media.desktopUp`
    max-width: 450px;
  `}

  img {
    /* Definite height, not just a cap: inside this shrink-to-fit link an SVG with only a
       viewBox would otherwise resolve to zero width. Width follows the aspect ratio. */
    display: block;
    ${responsiveHeight(LOGO_HEIGHT, h => `height: ${h}px; max-height: ${h}px;`)}
    width: auto;
    max-width: 100%;
    object-fit: contain;
    object-position: left center;
  }
`;

// External link for Logo Image
export const LogoLink = styled(ExternalLink)`
  ${logoLinkStyles}
`;

export const LogoLinkDefault = styled(Link)`
  ${logoLinkStyles}
`;
// Wraps the Logo and Navigation Links
export const Header = styled(Container)`
  width: 100%;
  flex: 1;
  ${responsiveHeight(HEADER_HEIGHT, h => `height: ${h}px;`)}
  display: flex;
  align-items: center;

  ${({ theme }) => theme.media.desktopUp`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `}
`;

// Icon that toggles menu for small breakpoints
export const MenuButton = styled(IconButton)`
  margin-left: auto;
  height: 100%;
  /* Keep a comfortable tap target on phones even as the header gets shorter */
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;

  /* The shared Button nudges down 1px on press; keep the menu toggle still */
  &:active {
    position: static;
    top: 0;
  }

  ${({ theme }) => theme.media.desktopUp`
    display: none;
  `}
`;

// Top level element of the header
export const HeaderWrapper = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 50px;
  padding: 0 20px;
  ${headerBackground}
  color: ${({ theme }) => theme.brand.headerText};

  position: fixed;
  right: 0;
  left: 0;
  top: 0;
  z-index: 3;
`;
